export default __webpack_public_path__ + "static/media/boing.873d41a6.mp3";